import { render } from "./SmartHomeComponent.vue?vue&type=template&id=f7642474&ts=true"
import script from "./SmartHomeComponent.vue?vue&type=script&lang=ts"
export * from "./SmartHomeComponent.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__